const NewDealsWidget = require("../Widgets/new-deals-widget");
const WonDealsWidget = require("../Widgets/won-deals-widget");
const LostDealsWidget = require("../Widgets/lost-deals-widget");
const ProductsBestSellersWidget = require("../Widgets/products-best-sellers-widget");
const ProfitableDealOriginsWidget = require("../Widgets/profitable-deal-origins-widget");
const DealLossReasonsWidget = require("../Widgets/deal-loss-reasons");
const DealRankingWidget = require("../Widgets/deal-ranking");
const FunnelHealthWidget = require("../Widgets/funnel-health-widget");
const WinRateCountWidget = require("../Widgets/win-rate-count-widget");
const WinRateAmountWidget = require("../Widgets/win-rate-amount-widget");
const ForgottenOrganizationsWidget = require("../Widgets/forgotten-organizations-widget");
const FinishedActivitiesWidget = require("../Widgets/finished-activities-widget");
const ScheduledTasksWidget = require("../Widgets/scheduled-tasks");
const FunnelMovesWidget = require("../Widgets/funnel-moves-widget");
const DateRangePicker = require("app/shared/components/DateRangePicker/date-range-picker");
const ButtonGroup = require("app/shared/components/ButtonGroup/button-group");
const Button = require("app/shared/components/Button/button");
const UserSelectFilter = require("app/screens/Activity/components/ActivityList/user-select-filter");
const TeamSelectFilter = require("app/shared/components/TeamSelectFilter/team-select-filter");
const FunnelSelectFilter = require("app/shared/components/FunnelSelectFilter/funnel-select-filter");
const date = require("app/util/formatter/date");
var _ = require("underscore");
var betaURL = require("app/util/config/beta-url");

const Dashboard = React.createClass({
  getInitialState: function() {
    return ({
      period: {
        startDate: moment().startOf("month"),
        endDate: moment().endOf("month")
      },
      comparison: {
        startDate: moment().add(-1, "month").startOf("month"),
        endDate: moment().add(-1, "month").endOf("month")
      },
      selectedUsersFromTeam: [],
      selectedUsers: "",
      selectedFunnel: this.props.funnel,
    });
  },

  getDefaultProps: function() {
    return ({
      periodStartDateInputId: "dashboard-period-start-date-input",
      periodEndDateInputId: "dashboard-period-end-date-input",
      comparisonStartDateInputId: "dashboard-comparison-start-date-input",
      comparisonEndDateInputId: "dashboard-comparison-end-date-input"
    });
  },

  onPeriodDateSelected: function(_date, event) {
    const selectedDate = date.formatDateFromJQueryDateUI(event);
    let period = Object.assign({}, this.state.period);

    if (event.id == this.props.periodStartDateInputId) {
      period.startDate = moment(selectedDate).startOf("day");
    }
    else if (event.id == this.props.periodEndDateInputId) {
      period.endDate = moment(selectedDate).endOf("day");
    }

    let comparison = date.getImmediateComparisonRange(period.startDate, period.endDate);

    $("#" + this.props.comparisonStartDateInputId)
      .datepicker("setDate", date.formatDateToJQueryDateUI(comparison.startDate));
    $("#" + this.props.comparisonEndDateInputId)
      .datepicker("setDate", date.formatDateToJQueryDateUI(comparison.endDate));

    this.setState({ period, comparison });
  },

  onComparisonDateSelected: function(_date, event) {
    const selectedDate = date.formatDateFromJQueryDateUI(event);
    let comparison = Object.assign({}, this.state.comparison);

    if (event.id == this.props.comparisonStartDateInputId) {
      comparison.startDate = moment(selectedDate);
    }
    else if (event.id == this.props.comparisonEndDateInputId) {
      comparison.endDate = moment(selectedDate);
    }

    this.setState({ comparison });
  },

  getSelectedUsers: function(usersFromTeamSelection, singleUserSelection) {
    if (usersFromTeamSelection.length > 0 && singleUserSelection) {
      var selectedUsers = usersFromTeamSelection.concat([singleUserSelection])
      return _.uniq(selectedUsers);
    } else if (singleUserSelection) {
      return [singleUserSelection];
    } else if (usersFromTeamSelection.length > 0) {
      return _.uniq(usersFromTeamSelection);
    } else {
      return [];
    }
  },

  onUserSelected: function(type, userId) {
    if (type == "userId") {
      userId = parseInt(userId);
      var selectedUsers = this.getSelectedUsers(this.state.selectedUsersFromTeam, userId);

      this.setState({
        selectedSingleUser: userId,
        selectedUsers: selectedUsers
      });
    }
  },

  onTeamSelected: function(_, teamId, userIdsInTeam) {
    var selectedUsers = this.getSelectedUsers(userIdsInTeam, this.state.selectedSingleUser);

    this.setState({
      selectedUsersFromTeam: userIdsInTeam,
      selectedUsers: selectedUsers,
      selectedTeam: teamId
    });
  },

  onFunnelSelected: function(_, funnel) {
    this.setState({
      selectedFunnel: funnel
    });
  },

  getReportsConversionURL: function() {
    var baseURL = betaURL() + '/reports/conversion';

    if (this.state.selectedFunnel) {
      return baseURL + '?funnel_id=' + this.state.selectedFunnel;
    }
    return baseURL;
  },

  getCustomDashboardURL: function() {
    return betaURL() + '/reports/custom-dashboard?originParam=panel';
  },

  render: function() {
    return (
      <div className="bg-lightestGray mh-full">
        <header className="container-fluid p-20 bg-primaryGray">
          <div className="row">
            <div className="col-md-4 ta-l">
              <div className="dropdown selectGroup c-black">
              <button type="button" data-toggle="dropdown" className="dropdownDefault fs-14">
                {this.state.period.startDate.format("DD MMM, YYYY")}
                <span> até </span>
                {this.state.period.endDate.format("DD MMM, YYYY")}
                <span className="custom-glyphicon icon-chevron-down dropdown-caret"></span>
              </button>
              <div className="dropdown-menu p-20">
                <div className="d-g grid-2 align-center gg-10">
                  <label>Período</label>
                  <DateRangePicker
                    inputWidth="120px"
                    readOnly={false}
                    inputBeginDateId={this.props.periodStartDateInputId}
                    inputEndDateId={this.props.periodEndDateInputId}
                    beginDate={this.state.period.startDate.format("YYYY-MM-DD")}
                    endDate={this.state.period.endDate.format("YYYY-MM-DD")}
                    handleSelection={this.onPeriodDateSelected}
                  />

                  <label>Comparativo</label>
                  <DateRangePicker
                    inputWidth="120px"
                    readOnly={false}
                    inputBeginDateId={this.props.comparisonStartDateInputId}
                    inputEndDateId={this.props.comparisonEndDateInputId}
                    beginDate={this.state.comparison.startDate.format("YYYY-MM-DD")}
                    endDate={this.state.comparison.endDate.format("YYYY-MM-DD")}
                    handleSelection={this.onComparisonDateSelected}
                  />
                </div>
              </div>
              </div>
            </div>

            <div className="col-md-4 ta-c">
              <ButtonGroup className="btn-group-nav">
                <Button type="filter" className="selected minw-150">Painel</Button>
                <Button type="filter" className="minw-150" href={{url: "/sistema/relatorios/criar.php", name: "_top"}}>
                  Métricas
                </Button>
                <Button type="filter" className="minw-150" href={{url: this.getCustomDashboardURL(), name: "_top"}}>
                  Análises avançadas
                  <span style={{backgroundColor: "#5C6BC0", borderRadius: "50%", width: "8px", height: "8px", display: "inline-block", verticalAlign: "middle", marginLeft: "5px"}}></span>
                </Button>
              </ButtonGroup>
            </div>

            <div className="col-md-4 ta-r">
              <FunnelSelectFilter
                className="w-150 d-ib mr-10"
                setFilter={this.onFunnelSelected}
                filters={this.state} />
              <UserSelectFilter
                className="d-ib mr-10"
                setFilter={this.onUserSelected}
                filters={{userId: ""}}
                showLabel={false}
                defaultOptionLabel="Usuários" />
              <TeamSelectFilter
                className="d-ib"
                setFilter={this.onTeamSelected} />
            </div>
          </div>
        </header>

        <main className="container">
          <div className="d-g grid-4 row-gap-20 col-gap-40 p-40">
            <WonDealsWidget
              period={this.state.period}
              comparison={this.state.comparison}
              users={this.state.selectedUsers}
              selectedUser={this.state.selectedSingleUser}
              selectedTeam={this.state.selectedTeam}
              funnel={this.state.selectedFunnel}
            />

            <NewDealsWidget
              period={this.state.period}
              comparison={this.state.comparison}
              users={this.state.selectedUsers}
              selectedUser={this.state.selectedSingleUser}
              selectedTeam={this.state.selectedTeam}
              funnel={this.state.selectedFunnel}
            />

            <LostDealsWidget
              period={this.state.period}
              comparison={this.state.comparison}
              users={this.state.selectedUsers}
              selectedUser={this.state.selectedSingleUser}
              selectedTeam={this.state.selectedTeam}
              funnel={this.state.selectedFunnel}
            />

            <WinRateCountWidget
              period={this.state.period}
              comparison={this.state.comparison}
              users={this.state.selectedUsers}
              funnel={this.state.selectedFunnel}
            />

            <WinRateAmountWidget
              period={this.state.period}
              comparison={this.state.comparison}
              users={this.state.selectedUsers}
              funnel={this.state.selectedFunnel}
            />

            <ProductsBestSellersWidget
              period={this.state.period}
              users={this.state.selectedUsers}
              selectedUser={this.state.selectedSingleUser}
              selectedTeam={this.state.selectedTeam}
              funnel={this.state.selectedFunnel}
            />

            <DealLossReasonsWidget
              period={this.state.period}
              users={this.state.selectedUsers}
              selectedUser={this.state.selectedSingleUser}
              selectedTeam={this.state.selectedTeam}
              funnel={this.state.selectedFunnel}
            />

            <ProfitableDealOriginsWidget
              period={this.state.period}
              users={this.state.selectedUsers}
              selectedUser={this.state.selectedSingleUser}
              selectedTeam={this.state.selectedTeam}
              funnel={this.state.selectedFunnel}
            />

            <DealRankingWidget
              period={this.state.period}
              users={this.state.selectedUsers}
              funnel={this.state.selectedFunnel}
            />

            <ForgottenOrganizationsWidget
              users={this.state.selectedUsers}
            />

            <FunnelHealthWidget
              users={this.state.selectedUsers}
              funnel={this.state.selectedFunnel}
              defaultFunnel={this.props.funnel}
            />

            <FunnelMovesWidget
              funnel={this.state.selectedFunnel}
              period={this.state.period}
              users={this.state.selectedUsers}
            />

            <FinishedActivitiesWidget
              period={this.state.period}
              users={this.state.selectedUsers}
            />

            <ScheduledTasksWidget
              period={this.state.period}
              users={this.state.selectedUsers}
            />
          </div>
        </main>
      </div>
    );
  }
});

module.exports = Dashboard;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Dashboard/dashboard.jsx